import { DocumentType } from "../../framework.core/DocumentType";

export class ReportArgs {
    docType: DocumentType = DocumentType.Unknown;
    formCaption: string = '';
    subject: string = '';
    stamp : boolean = false;
    useMultiCur: boolean = false;
    toCompanyid: string = '';
    tbName: string = '';
    tbId: string = '';
    userID: string = '';
    memo: string = '';
    copies: number = 0;
    isExportToExcel: boolean = false;
    ccEmail: string = '';
    bccEmail: string = '';
    toEmail: string = '';
    
    useUserContact: boolean = false;

    emailTemplateName: string = '';
    fileAttachments: string[] = [];

    constructor(init?:Partial<ReportArgs>) {
        Object.assign(this, init);
    }
}

// ** FrontEnd 에서 사용되지 않는 Property는 주석 처리함.

//#region #A, B, C, D

export class AciHistoryArgs extends ReportArgs {
    dataCompanyID: number = 0;
    houseID: number = 0;

    constructor(init?:Partial<AciHistoryArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AccountBalanceByEntityArgs extends ReportArgs {
    dataCompanyID: number = 0;
    toDate: string | null = null;
    comType: string = '';
    comId: number = 0;
    comName: string = '';
    subCode: string = '';
    fromGLNo: string = '';
    toGLNo: string = '';
    branch: string = '';
    showForeign: boolean = false;
    salesCostOnly: string = '';         // Empty : ''(Account Code 모두 표시), Sales : 'S', Cost : 'C', Sales & Cost : 'ALL' 
    sortOrder:  string = '';

    constructor(init?:Partial<AccountBalanceByEntityArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AgntStatementArgs extends ReportArgs {
    dataCompanyID: number = 0;
    agent: number = 0;
    departments: string = '';
    stDate: string | null = null;
    edDate: string | null = null;
    paidType: string = '';
    sortNum: number = 0;
    dateType: string = '';
    eurRate: number = 0;
    currency: string = '';
    showDetail: boolean = false;
    showPstatus: boolean = false;
    branch: string = '';
    received: boolean = false;
    customForm: boolean = false;
    //accountID: string = '';
    billto: number = 0;
    descptDetail: boolean = false;
    confirmed: boolean = false;
    selectFieldValue : string | null = null;
    invNewDesignForm: boolean = false;
    crdbNewDesignForm: boolean = false;
    showDuty: boolean = false;
    //recognizedOnly: boolean = false; 사용하지 않는 필드

    constructor(init?:Partial<AgntStatementArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AIManifestArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //sOrB: boolean = false;

    constructor(init?:Partial<AIManifestArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AmsHistoryArgs extends ReportArgs {
    dataCompanyID: number = 0;
    houseID: number = 0;
    amsMode: string = '';

    constructor(init?:Partial<AmsHistoryArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AmsHistoryMasterArgs extends ReportArgs {
    dataCompanyID: number = 0;
    masterID: number = 0;
    amsMode: string = '';

    constructor(init?: Partial<AmsHistoryMasterArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AmsUsageArgs extends ReportArgs  {
    acctType: string = '';
    //amsId: string = '';
    amsGroupId: string = '';
    dateFrom: string = '';
    dateTo: string = '';
    hblNumber: boolean = false;
    amsMode: string = '';
    useEManifest: boolean = false;
    aciSearchStr: string = '';

    constructor(init?:Partial<AmsUsageArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class APArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    requestBy: string = '';
    branch: string = '';
    country: string = '';

    constructor(init?:Partial<APArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class ArrivalNoticeArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    showCharge: string = '';
    hidePPCC: string = '';
    customForm: boolean = false;
    //legalTerms: boolean = false;
    message: string = '';
    useMultiCur: boolean = false;
    caption: string = '';
    legalTerms: boolean = false;
    showFootprint: string = '';
    
    //FOR ATTACH GUARANTEE LETTER
    turnInCode: string = ''
    emptyRtnID:number = 0;
    fileNo: string = '';
    opEmail: string = '';
    withAttachGuaranteeLetter: boolean = false;
    withAttachSOCGuaranteeLetter: boolean = false;
    arrivalNoticeBatchInfos: ArrivalNoticeBatchInfo[] = [];
    newDesignForm: boolean = false;
    invNewDesignForm: boolean = false;
    emptyRef: string = '';
    returnDepot: string = '';

    constructor(init?:Partial<ArrivalNoticeArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class AuthEntryArgs extends ReportArgs {
    authEntryBatchInfos: AuthEntryBatchInfo[] = [];

    constructor(init?: Partial<AuthEntryArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class IRC225Args extends ReportArgs {
    customForm: boolean = false;
    useSignature: boolean = false;
    totalHawb: string = '';
    customsCity: string = '';

    constructor(init?:Partial<IRC225Args>) {
        super();
        Object.assign(this, init);
    }
}
export class AWBArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    forUse: string = '';
    orgCpy: string = '';
    shipperName: string = '';
    pShipperName: string = '';
    carrierName: string = '';
    firstCarrier: string = '';
    destCountry: string = '';
    //tFontName: string = '';
    branch: string = '';
    companyName: string = '';
    remark: string = '';
    remarkFont: string = '';
    notShowRule: boolean = false;
    useSignature: boolean = false;
    deliveryOption: boolean = false;
    showSellingRate: boolean = false;
    attachIATATerm: boolean = false;
    carrierOption: boolean = false;
    awbBatchInfos?: AWBBatchInfo[] = [];

    constructor(init?:Partial<AWBArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class BalanceSheetArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    strDate: string | null = null;
    edDate: string | null = null;
    previousDate: string | null = null;
    printYears: number = 0;
    branch: string = '';
    reportType: string = '';
    useLocalLanguage: boolean = false;
    showAllBranch: boolean = false;
    userBranch: string = '';
    showAllUserBranch: boolean = false;

    constructor(init?:Partial<BalanceSheetArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BalanceSheetKRArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    strDate: string | null = null;
    endDate: string | null = null;
    branch: string = '';
    showPreviousYear: boolean = false;
    isDetail: boolean = false;

    constructor(init?:Partial<BalanceSheetKRArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BankDraftArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    dataOnly: string = '';
    issueDate: string = '';
    usDollar: string = '';
    atSight: string = '';
    payTo: string = '';
    payToAddr: string = '';
    lCno: string = '';
    openBank: string = '';
    openDate: string = '';
    cnee: string = '';
    cneeAddr: string = '';
    drawnBank: string = '';
    drawnBankAddr: string = '';
    bankRef: string = '';
    signature: string = '';
    negoBank: string = '';
    negoBankAddr: string = '';
    draftNo: string = '';
    checkOP: string = '';
    initial: string = '';
    otherInst: string = '';
    branch: string = '';
    multiName: string = '';
    title: string = '';
    billsLanding: string = '';
    blCopy: string = '';
    com: string = '';
    ins: string = '';
    ctf: string = '';
    con: string = '';
    pkn: string = '';
    wgt: string = '';
    amdDate: string = '';

    constructor(init?:Partial<BankDraftArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BankReconHistoryArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    strDate: string | null = null;
    endDate: string | null = null;
    bankID: number = 0;
    //edate: string = '';

    constructor(init?:Partial<BankReconHistoryArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BookConfirmArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //customForm: boolean = false;

    constructor(init?:Partial<BookConfirmArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BookingAIFGArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<BookingAIFGArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BookingArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    userID: string = '';
    date1: string | null = null;
    date2: string | null = null;
    branch: string = '';
    period: string = '';

    constructor(init?:Partial<BookingArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BranchPerformanceArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    strDate: string = '';
    edDate: string = '';
    actStartDate: string = '';
    type: string = '';
    reportType: string = '';
    branch: string = '';
    isEnableBranchOption: boolean = false;
    use12Months: boolean = false;

    constructor(init?:Partial<BranchPerformanceArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class BrokerageArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    carrier: number = 0;
    stDate: string = '';
    edDate: string = '';

    constructor(init?:Partial<BrokerageArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class CancelITArgs extends ReportArgs {
    tableName: string = '';
    username: string = '';
    attn: string = '';
    place: string = '';

    constructor(init?:Partial<CancelITArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class CarrierCertArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<CarrierCertArgs>) {
        super();
        Object.assign(this, init);
    }    
}
export class CertCompArgs extends ReportArgs {

    constructor(init?:Partial<CertCompArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CheckArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    copyOnly: boolean = false;
    formName: string = '';
    //tPrinterPath: string = '';
    //tFontName: string = '';
    fromNo: string = '';
    toNo: string = '';
    bank: number = 0;

    constructor(init?:Partial<CheckArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CheckSubArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //isCheckAttach: boolean = false;

    constructor(init?:Partial<CheckSubArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class CheckReqArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //requestBy: string = '';
    //branch: string = '';
    //recordList: CheckReq[] = [];
    //isNodata: boolean = false;

    constructor(init?:Partial<CheckReqArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CheckReqCommonArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    requestBy: string = '';
    branch: string = '';
    //country: string = '';
    reportType: string = '';

    constructor(init?:Partial<CheckReqCommonArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CheckReqNoDetailArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //requestBy: string = '';
    //branch: string = '';
    //recordList: CheckReqNoDetail[] = [];
    //isNodata: boolean = false;

    constructor(init?:Partial<CheckReqNoDetailArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ChkMessengerArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<ChkMessengerArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class COArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';

    constructor(init?:Partial<COArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CombineArgs extends ReportArgs {
    //args: ReportArgs[] = [];

    constructor(init?:Partial<CombineArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CommInvArgs extends ReportArgs {
    //date: string = '';
    caption: string = '';
    //dataCompanyID: number = 0;

    constructor(init?:Partial<CommInvArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CommInvPackRiderArgs extends ReportArgs {
    //riderMemo: string = '';
    //heading: string = '';

    constructor(init?:Partial<CommInvPackRiderArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CompanyDetailArgs extends ReportArgs {

    constructor(init?:Partial<CompanyDetailArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ContainerNumbersArgs extends ReportArgs {
    //columnCount: number = 0;
    //containerCount: number = 0;
    //containerNoOnly: boolean = false;
    //outbound: boolean = false;
    //showPickupNo: boolean = false;
    //showLastFreeDay: boolean = false;
    //showWeight: boolean = false;
    //showPackage: boolean = false;

    constructor(init?:Partial<ContainerNumbersArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ContainerRider2Args extends ReportArgs {
    //dataCompanyID: number = 0;
    //title: string = '';
    //header: boolean = false;
    //branch: string = '';

    constructor(init?:Partial<ContainerRider2Args>) {
		super();
		Object.assign(this, init);
	}
}
export class CorrNoticeArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';

    constructor(init?:Partial<CorrNoticeArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CRDBArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    crDbBatchInfos: CrDbBatchInfo[] = []
    customForm: boolean = false;
    dbConnOname: string = '';
    billto: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;
    sortBy: number = 0;
    dateType: string = '';
    newDesignForm: boolean = false;
    
    constructor(init?:Partial<CRDBArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class CustomerNonActivityArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    department: string = '';
    salesMan: string = '';
    dateFrom: string = '';
    dateTo: string = '';
    type: string = '';
    type1: string = '';

    constructor(init?:Partial<CustomerNonActivityArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class DailyAccountActivitySub3DetailArgs extends ReportArgs 
{
    //dataCompanyID: number = 0;
    branch: string = '';
    date: string = '';
    reportType: string = '';
    showInactive: string = '';
    showBadARBank: string = '';

    constructor(init?:Partial<DailyAccountActivitySub3DetailArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class DailyAccountActivitySub4DetailArgs extends ReportArgs {
    date: string = '';
    //dataCompanyID: number = 0;
    branch: string = '';
    reportType: string = '';
    isFuture: boolean = false;

    constructor(init?:Partial<DailyAccountActivitySub4DetailArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class PaymentPrepArgs extends ReportArgs {
    date: string = '';
    TbName: string = '';
    TbId: string = '';

    constructor(init?:Partial<DailyAccountActivitySub4DetailArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class DailyAccountCommonArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';
    reportType: string = '';
    showInactive: string = '';
    date: string = '';
    edate: string = '';
    showBadARBank: string = '';
    bankInfos: string = '';
    bankBranch: string = '';
    //viewType: string = '';

    constructor(init?:Partial<DailyAccountCommonArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class DailyAccountSub2Args extends ReportArgs {
    stDate: string | null = null;
    edDate: string | null = null;
    branch: string = '';
    bankID: number = 0;
    valStr: string = '';
    currency: string = '';
    displayBankAccount: boolean = false;
    //dataCompanyID: number = 0;

    constructor(init?:Partial<DailyAccountSub2Args>) {
        super();
        Object.assign(this, init);
    }
}
export class DevannArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    instruction: string = '';
    cfs: number = 0;
    cy: number = 0;
    branch: string = '';
    country: string = '';

    constructor(init?:Partial<DevannArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class DOArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    branch: string = '';
    deliveryTo: string = '';
    trucker: string = '';
    remark: string = '';
    ppcc: string = '';
    carrierFieldType: number = 0;
    remarkAdd: string = '';
    forCnee: boolean = false;
    truckingCoID: number = 0;
    amsblNo: string = '';
    newDesignForm: boolean = false;

    constructor(init?:Partial<DOArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class DockReceiptArgs extends ReportArgs {
    newDesignForm: boolean = false;

    constructor(init?:Partial<DockReceiptArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class DutyBalanceArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    date: string | null = null;
    reportType: string = '';

    constructor(init?:Partial<DutyBalanceArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class DutyPendingsArgs extends ReportArgs {
    rptType: string = '';
    date: string | null = null;
    periodFrom: string | null = null;
    periodTo: string | null = null;
    dateType: string = '';
    includeDraft:  boolean = false;

    constructor(init?:Partial<DutyPendingsArgs>) {
		super();
		Object.assign(this, init);
	}
}

//#endregion

//#region #E, F, G, H

export class EmptyCntrRtnArgs extends ReportArgs {
    fileNo: string = '';
    emptyRtnID: number = 0;
    turnInCode: string = '';
    opEmail: string = '';
    //customForm: boolean = false;
    //acmeID: string = '';

    constructor(init?:Partial<EmptyCntrRtnArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class SOCEmptyCntrRtnArgs extends ReportArgs {
    fileNo: string = '';
    emptyRtnID: number = 0;
    turnInCode: string = '';
    opEmail: string = '';

    constructor(init?:Partial<SOCEmptyCntrRtnArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class ETAArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;
    customer: number = 0;
    agent: number = 0;
    ref: string = '';
    branch: string = '';
    finalETA: string = '';
    operatorName: string = '';
    svcRep: string = '';
    companyGroup: string = '';
    notReleased: string = '';

    constructor(init?:Partial<ETAArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ExdecArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';

    constructor(init?:Partial<ExdecArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class EmpPerformanceArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    periodFrom: string = '';
    periodTo: string = '';
    sortFieldNum: string = '';
    //branch: string = '';
    type: string = '';
    empName: string = '';
    viewType: string = '';
    selectFieldValue: string = '';

    constructor(init?:Partial<EmpPerformanceArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ExdectransitArgs extends ReportArgs {

    constructor(init?:Partial<ExdectransitArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class FreightANArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //international: string = '';

    constructor(init?:Partial<FreightANArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class GeneralLedgerArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';
    dateFrom: string | null = null;
    dateTo: string | null = null;
    glNoFrom: string = '';
    glNoTo: string = '';
    subCode: string = '';

    constructor(init?:Partial<GeneralLedgerArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class GLAgingByEntryArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';
    glCode: string = '';
    subCode: string = '';
    dateTo: string | null = null;
    sortOrder: string = '';

    constructor(init?:Partial<GLAgingByEntryArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class GLAgingByEntryDetailArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    branch: string = '';
    glCode: string = '';
    subCode: string = '';
    dateTo: string | null = null;
    customerId: number = 0;
    customerType: string = '';
    isForeignBank: boolean = false;

    constructor(init?:Partial<GLAgingByEntryDetailArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class GermanSAdviceArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //customForm: boolean = false;

    constructor(init?:Partial<GermanSAdviceArgs>) {
		super();
		Object.assign(this, init);
	}
}

//#endregion

//#region #I, J, K, L

export class IncomeStatementArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    strDate: string = '';
    edDate: string = '';
    previousStrdate: string | null = null;
    previousEndDate: string | null = null;
    previousStrdate2: string | null = null;
    previousEndDate2: string | null = null;
    previousStrdate3: string | null = null;
    previousEndDate3: string | null = null;
    previousStrdate4: string | null = null;
    previousEndDate4: string | null = null;
    //previousYear: string = '';
    reportOption: string = '';
    reportType: string = '';
    branch: string = '';
    acualStartDate: string | null = null;
    reportType2: string = '';
    sortType: string = '';
    useLocalLanguage: boolean = false;
    showAllBranch: boolean = false;
    userBranch: string = '';
    showAllUserBranch: boolean = false;
    ignoreHQBillings: boolean = false;

    constructor(init?:Partial<IncomeStatementArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class IncomeStatementKRArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    beginDate: string | null = null;
    fromDate: string = '';
    toDate: string = '';
    prevFromDate: string | null = null;
    prevToDate: string | null = null;
    showPreviousYear: boolean = false;
    byMonth: boolean = false;
    isDetail: boolean = false;
    branch: string = '';

    constructor(init?:Partial<IncomeStatementKRArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class InvoiceArgs extends ReportArgs  {
    invoiceBatchInfos: InvoiceBatchInfo[] = []
    newDesignForm: boolean = false;

    constructor(init?: Partial<InvoiceArgs>) {
        super();
        //this.docType = DocumentType.Invoice;
        //this.formCaption = "Invoice"
        Object.assign(this, init);
    }
}
export class ITArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    branch: string = '';
    nos: string = '';
    //customForm: boolean = false;

    constructor(init?:Partial<ITArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ISFUsageArgs extends ReportArgs {
    groupID: string = '';
    startDate: string = '';
    endDate: string = '';
    showdetail: boolean = false;
    user: string = '';

    constructor(init?:Partial<ISFUsageArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class AesUsageArgs extends ReportArgs {
    groupID: string = '';
    startDate: string | null = '';
    endDate: string | null = '';
    showDetail: boolean = false;
    user: string = '';

    constructor(init?:Partial<AesUsageArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class InlandArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;

    constructor(init?:Partial<InlandArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class InvenPickArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;
    centerNo: string = '';

    constructor(init?:Partial<InvenPickArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class InvenActivityArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;
    centerNo: string = '';

    constructor(init?:Partial<InvenActivityArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class InvenItemHistoryArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;
    centerNo: string = '';

    constructor(init?:Partial<InvenItemHistoryArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class IssueReadyArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    reportType: string = '';
    departments: string = '';
    billingsType: string = '';
    periodFrom: string | null = null;
    periodTo: string | null = null;
    useBillingsTypeVersion1: boolean = false;

    constructor(init?:Partial<IssueReadyArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ITLaserArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tPrinterPath: string = '';
    //customForm: boolean = false;
    //tFontName: string = '';
    nos: string = '';

    constructor(init?:Partial<ITLaserArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class JournalVoucherArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    stDate: string | null = null;
    edDate: string | null = null;
    language: string = '';
    branch: string = '';
    slipType: string = '';
    seqNo: string = '';
    journalKey: string = '';
    fromSeqNo: string = '';
    toSeqNo: string = '';

    constructor(init?:Partial<JournalVoucherArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class LabelArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    customer: string = '';
    formName: string = '';

    constructor(init?:Partial<LabelArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LienNoticeArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    remark: string = '';
    branch: string = '';

    constructor(init?:Partial<LienNoticeArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LiftingArgs extends ReportArgs  {
    branch: string = '';
    startDate: string | null = null;
    endDate: string | null = null;
    option: string = '';
    agent: string = '';
    gr_40HTEU: string = '';
    gr_45TEU: string = '';
    //scac: string = '';
    amsMode: string = '';

    constructor(init?:Partial<LiftingArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LocalStatementArgs extends ReportArgs {
    dataCompanyID: number = 0;
    advance: string = '';
    completeInvo: string = '';
    //customForm: boolean = false;
    showDetail: boolean = false;
    useMultiCur: boolean = false;
    departs: string = '';
    departsIL: string = '';
    startDate: string | null = null;
    endDate: string | null = null;
    pastDue: string = '';
    excl0Term: boolean = false;
    currency: string = '';
    pBalShow: boolean = false;
    notShowOver: boolean = false;
    branch: string = '';
    reportType: string = '';
    asOf: string = '';
    dateType: string = '';
    billto: number = 0;
    invoiceOnly: boolean = false;
    paidType: string = '';
    sortType: string = '';
    invoiceIDs: string = '';
    selectFieldValue : string | null = null;
    invNewDesignForm: boolean = false;
    //recognizedOnly: boolean = false; 사용하지 않는 필드
    //tRs: number[] | null = null;
    showDuty: boolean = false;
    pastDueOnly: boolean = false;

    constructor(init?:Partial<LocalStatementArgs>) {
		super();
		Object.assign(this, init);
        this.docType = DocumentType.LocalStatement;
	}
}
export class LoadPlanArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    instruction: string = '';
    agent: number = 0;
    rstation: number = 0;
    branch: string = '';

    constructor(init?:Partial<LoadPlanArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LabelAirArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    masterPieceCount: number = 0;
    housePieceCount: number = 0;
    range: string = '';
    headerType: string = '';
    mutipleComID: number = 0;
    showHousePieceCount: number = 0;
    showHouseBLNo: number = 0;
    //formName: string = '';

    constructor(init?:Partial<LabelAirArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LabelPouchArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    pieceCount: string = '';
    //range: string = '';
    //formName: string = '';

    constructor(init?:Partial<LabelPouchArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LabelComAddressArgs extends ReportArgs {
    skipCount: number = 0;
    companyGroup: string = '';
    companyID: string = '';
    incudeCountry: string = '';
    formName: string = '';

    constructor(init?:Partial<LabelComAddressArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LabelFolderArgs extends ReportArgs {
    field1: string = '';
    field2: string = '';
    field3: string = '';
    field4: string = '';
    field5: string = '';
    field6: string = '';
    field7: string = '';
    field8: string = '';
    field9: string = '';
    field10: string = '';

    constructor(init?:Partial<LabelFolderArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LogDetailArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<LogDetailArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class LabelBookArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    housePieceCount: number = 0;

    constructor(init?:Partial<LabelBookArgs>) {
		super();
		Object.assign(this, init);
	}
}

//#endregion

//#region #M, N, O, P

export class ManifestArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<ManifestArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class MasterSetArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<MasterSetArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class MemoArgs extends ReportArgs {
    tbName: string = '';
    tbId: string = '';

    constructor(init?:Partial<MemoArgs>) {
		super();
        this.docType = DocumentType.Memo;
		Object.assign(this, init);
	}
}

export class NewAgingCommonArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    endingDate: string | null = null;
    branch: string = '';
    acmeID: string = '';
    useNewAcct: string = '';
    glNo: string = '';
    subCode: string = '';
    type: string = '';
    comId: number = 0;
    comId2: string = '';
    comType: string = '';
    showCurrency: boolean = false;
    showBalanceOnly: boolean = false;
    fromOtherReport: boolean = false;
    doNotShowZeroBal: boolean = false;
    groupSalesman: boolean = false;
    salesMan: string = '';
    isFromMain: boolean = false;
    sortOrderSummary: boolean = false; // <jhlee.251001 - Sort Order 옵션을 체크 박스로 변경 />
    sortOrder: boolean = false; // <jhlee.251001 - Sort Order 옵션을 체크 박스로 변경 />
    sortOrderEx: string = '';
    constructor(init?: Partial<NewAgingCommonArgs>) {
        super();
        this.docType = DocumentType.AgingAR;
        Object.assign(this, init);
    }
}
export class NewDeferredArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    salesFrom: string | null = null;
    salesTo: string | null = null;
    departments: string = '';
    viewType: string = '';
    sortOrder: string = '';
    branch: string = '';
    showNoBilling: string = '';

    constructor(init?:Partial<NewDeferredArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class NewGeneralJournalArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    startDate: string | null = null;
    endingDate: string | null = null;
    branch: string = '';
    subCode: string = '';

    constructor(init?:Partial<NewGeneralJournalArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class NewProfitArgs extends ReportArgs {
    isHouseMode: boolean = false;
    //dataCompanyID: number = 0;
    groupFieldName: string = '';
    selectFieldValue: string = '';
    periodType: string = '';
    periodFrom: string | null = null;
    periodTo: string | null = null;
    sortFieldNum: number = 0;
    branch: string = '';
    viewType: string = '';
    lineItems: string = '';
    reportType: string = '';
    dataBLName: string = '';
    isSPReport: boolean = false;
    departments: string = '';
    lossOnly:boolean = false;
    isNotDetailSummary:boolean = false;
    mhType: string = '';
    constructor(init?:Partial<NewProfitArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class NewVendorCostDetailArgs extends ReportArgs {
    reportType: string = '';
    departments: string = '';
    strDate: string | null = null;
    endDate: string | null = null;
    vendor: string = '';
    vendorID: number = 0;
    paidStatus: string = '';
    sortVendorCost : boolean = false;
    selectFieldValue : string | null = null;
    branch: string = '';
    //dataCompanyID: number = 0;

    constructor(init?:Partial<NewVendorCostDetailArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class NewVendorCostSummaryArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    reportType: string = '';
    departments: string = '';
    strDate: string | null = null;
    endDate: string | null = null;
    paidStatus: string = '';
    sortVendorCost: boolean = false;
    selectFieldValue: string = '';
    branch: string = '';

    constructor(init?:Partial<NewVendorCostSummaryArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class OIHouseBLArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    houseBLNo: string = '';
    branch: string = '';
    //customForm: boolean = false;

    constructor(init?:Partial<OIHouseBLArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class OIAuditArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    dateType: string = '';
    stDate: string = '';
    edDate: string = '';
    branch: string = '';
    agent: number = 0;
    actMgr: string = '';
    svcRep: string = '';

    constructor(init?:Partial<OIAuditArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class OutstandArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    reportType: string = '';
    type: string = '';
    custWare: string = '';
    agent: string = '';
    stDate: string | null = null;
    edDate: string | null = null;
    dateType: string = '';
    branch: string = '';
    moveType: string = '';

    constructor(init?:Partial<OutstandArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class OOHouseBLArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    dataOnly: boolean = false;
    formName: string = '';
    fcr: string = '';
    authorized: string = '';
    fcR_RecBy: string = '';
    fcR_RecDateTime: string = '';
    fcR_RecPerson: string = '';
    //tFontName: string = '';
    showRemark: boolean = false;
    totalNoContPkgs: string = '';
    showBLType: string = '';
    agentRef: string = '';
    actCarrier: string = '';
    showVessel: boolean = false;
    showOnBoard: boolean = false;
    showErrorAttach: boolean = false;
    pageCount: number = 0;
    showIssue: boolean = false;
    showExRate: boolean = false;
    ooHouseBLBatchInfos: OOHouseBLBatchInfo[] = [];
    showFootprint: string = '';

    constructor(init?:Partial<OOHouseBLArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class OutboundCargoManifestArgs extends ReportArgs {
    dataCompanyID: number = 0;
    manifestType: string = '';
    houseAgentIDs: string = '';
    branch: string = '';
    contact: string = '';
    from: string = '';

    constructor(init?:Partial<OutboundCargoManifestArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class OEUSDAArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<OEUSDAArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class OutStateArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<OutStateArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class PayrollSummaryArgs extends ReportArgs {
    payrollId: number = 0;
    payrollGroupId: number = 0;

    constructor(init?:Partial<PayrollSummaryArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class PeriodicGLDetailArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    reportType: string = '';
    stDate: string | null = null;
    edDate: string | null = null;
    stnum: string = '';
    ednum: string = '';
    custType: string = '';
    custID: number = 0;
    custName: string = '';
    glSubCode: string = '';
    branch: string = '';
    showForeign: boolean = false;

    constructor(init?:Partial<PeriodicGLDetailArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class PickupArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    date: string | null = null;
    toTrucking: string = '';
    pickupRefNo: string = '';
    pickupDate: string | null = null;
    pickupAt: string = '';
    pickupContact: string = '';
    deliverRefNo: string = '';
    deliverDate: string | null = null;
    deliverTo: string = '';
    deliveryContact: string = '';
    billto: string = '';
    instruction: string = '';
    branch: string = '';
    commodity: string = '';
    //customForm: boolean = false;
    hbLnos: string = '';
    pkgs: string = '';
    weight: string = '';
    measurement: string = '';
    straightBlRider: boolean = false;
    flexiTankBlRider: boolean = false;
    showFootprint: string = '';

    id: string = '';
    tableName: string = '';

    newDesignForm: boolean = false;
    constructor(init?:Partial<PickupArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class PreliminaryClaimArgs extends ReportArgs {
    username: string = '';
    noticeTo: string = '';
    remark: string = '';
    vendorFlag: boolean = false;

    constructor(init?:Partial<PreliminaryClaimArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class PODArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    date: string | null = null;
    toCustomer: string = '';
    deliveryTo: string = '';
    remarks: string = '';
    branch: string = '';
    title: string = '';
    deliveryDate: string = '';
    signedBy: string = '';
    //show: boolean = false;

    constructor(init?:Partial<PODArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class PreAlertArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    customer: string = '';
    stDate: string = '';
    edDate: string = '';
    repType: string = '';

    constructor(init?:Partial<PreAlertArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class PendingListArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    shipper: string = '';
    stDate: string | null = null;
    edDate: string | null = null;
    reportType: string = '';
    branch: string = '';
    //shipped: string = '';

    constructor(init?:Partial<PendingListArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class PickSlipArgs extends ReportArgs {

    constructor(init?:Partial<PickSlipArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class PickUpOtherCountriesArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    date: string | null = null;
    toTrucking: string = '';
    pickupRefNo: string = '';
    pickupDate: string | null = null;
    pickupTime: string | null = null;
    pickupAt: string = '';
    deliverDate: string | null = null;
    deliverTime: string | null = null;
    deliverTo: string = '';
    billTo: string = '';
    instruction: string = '';
    branch: string = '';
    cargoDetails: string = '';
    poRefNo: string = '';

    constructor(init?:Partial<PickUpOtherCountriesArgs>) {
		super();
		Object.assign(this, init);
	}
}

//#endregion

//#region #Q, R, S, T, U

export class QuotationArgs extends ReportArgs {
    quoteID: number = 0;
    branch: string = '';

    constructor(init?:Partial<QuotationArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class ReportANandROrderPackageArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    caption: string = '';
    branch: string = '';
    country: string = '';
    showCharge: string = '';
    hidePPCC: string = '';
    //customForm: boolean = false;
    legalTerms: boolean = false;
    //message: string = '';
    useMultiCur: boolean = false;
    date: string = '';
    sendID: number = 0;
    releaseTo: string = '';
    specialInstructions: string = '';
    title: string = '';

    //FOR ATTACH GUARANTEE LETTER
    turnInCode: string = ''
    emptyRtnID:number = 0;
    fileNo: string = '';
    opEmail: string = '';
    
    withAttachGuaranteeLetter: boolean = false;
    newDesignForm: boolean = false;
    invNewDesignForm: boolean = false;
    withAttachSOCGuaranteeLetter: boolean = false;
    emptyRef: string = '';
    returnDepot: string = '';
    
    constructor(init?:Partial<ReportANandROrderPackageArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ReleaseArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    date: string = '';
    sendID: number = 0;
    releaseTo: string = '';
    specialInstructions: string = '';
    branch: string = '';
    title: string = '';

    constructor(init?:Partial<ReleaseArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ReleaseHistArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    agent: string = '';
    stDate: string = '';
    edDate: string = '';
    fldName: string = '';
    //oaType: string = '';
    ocean: boolean = false;
    air: boolean = false;

    constructor(init?:Partial<ReleaseHistArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ReportDocumentPackageArgs extends ReportArgs {
    sendToType: string = '';
    reportTypes: string = '';
    blFormName: string = '';
    companyID: number = 0;
    branch: string = '';
    authorized: string = '';
    shipperName: string = '';
    carrierName: string = '';
    firstCarrier: string = '';
    destCountry: string = '';
    awbRemark: string = '';
    awbRemarkFont: string = '';
    stamp: boolean = false;
    country: string = '';
    master: boolean = false;
    //entryTime: string | null = null;
    //customsDate: string | null = null;
    remark: string = '';
    awbShowUserSign: boolean = false;

    constructor(init?:Partial<ReportDocumentPackageArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class ReportAgentPackageArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    agentReportType: string = '';
    houseAgentID: string = '';
    reportTypes: string = '';
    blFormName: string = '';
    companyID: number = 0;
    branch: string = '';
    awbRemark: string = '';
    awbRemarkFont: string = '';
    billTo: number = 0;
    shipperName: string = '';
    showAwbUserSign: boolean = false;
    dlvryOption: boolean = false;
    contact: string = '';

    constructor(init?:Partial<ReportAgentPackageArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class SecondANArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    type: string = '';

    constructor(init?:Partial<SecondANArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class StraightBLArgs extends ReportArgs {
    toTrucking: string = '';
    sName: string = '';
    cName: string = '';
    pkgs: string = '';
    weight: string = '';

    constructor(init?:Partial<StraightBLArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class SAArgs extends ReportArgs {
    dataCompanyID: number = 0;
    forUse: string = '';
    remarks: string = '';
    branch: string = '';
    saBatchInfos: SABatchInfo[] = []

    constructor(init?:Partial<SAArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class FiveYearsDataReportArgs extends ReportArgs {
    year: number = 0;

    constructor(init?:Partial<FiveYearsDataReportArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class TopSalesByYearsArgs extends ReportArgs {
    customerType: string = '';
    asOfDate: string | null = null;
    quarters = {};

    constructor(init?:Partial<TopSalesByYearsArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class TSAArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    masterBLNo: string = '';
    branch: string = '';

    constructor(init?:Partial<TSAArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class TrialBalanceNewArgs extends ReportArgs {
    strDate: string | null = null;
    endDate: string | null = null;
    branch: string = '';
    //dataCompanyID: number = 0;
    useLocalLanguage: string = '';
    reportType: string = '';
    showAllBranch: boolean = false;
    userBranch: string = '';
    showAllUserBranch: boolean = false;
    
    constructor(init?:Partial<TrialBalanceNewArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class TransferArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    masterBLNo: string = '';
    branch: string = '';
    //sOrB: boolean = false;

    constructor(init?:Partial<TransferArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class IACCertificateArgs extends ReportArgs {
    branch: string = '';
    etd: string = '';
    date: string = '';
    iacRepPrintName: string = '';
    
    constructor(init?:Partial<IACCertificateArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class TelexReleaseArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<TelexReleaseArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class TrailerLoadArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //branch: string = '';

    constructor(init?:Partial<TrailerLoadArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class TransactionISArgs extends ReportArgs {
    jobId: number = 0;
    transaction: string = '';

    constructor(init?:Partial<TransactionISArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class TruckBLArgs extends ReportArgs {

    constructor(init?:Partial<TruckBLArgs>) {
		super();
		Object.assign(this, init);
	}
}


export class USDAArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    date: string = '';
    faxTo: string = '';
    chargeTo: string = '';
    faxTo1: string = '';
    title: string = '';
    remark: string = '';
    branch: string = '';
    usdaBatchInfos?: USDABatchInfo[] = []
    //customForm: boolean = false;

    constructor(init?:Partial<USDAArgs>) {
		super();
		Object.assign(this, init);
        
	}
}


//#endregion

//#region #V, W, X, Y, Z

export class VolumeCommonArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    departments: string = '';
    fieldOptionNum: string = '';
    viewType: string = '';
    groupFieldName: string = '';
    selectFieldValue: string = '';
    periodFrom: string | null = null;
    periodTo: string | null = null;
    //sortFieldNum: number = 0;
    //showFieldNum: number = 0;
    period: string = '';
    branch: string = '';
    //customForm: boolean = false;
    sortFieldName: string = '';
    nomi: number = 0;
    isHouse: boolean = false;

    constructor(init?:Partial<VolumeCommonArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class VatARAPArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    viewType: string = '';
    yearValue: string = '';
    periodType: string = '';
    periodValue: number = 0;

    constructor(init?:Partial<VatARAPArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class VesselAcctArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    vesselName: string = '';
    voyage: string = '';

    constructor(init?:Partial<VesselAcctArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class WhseLabelOthArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    //customer: string = '';
    //formName: string = '';
    range: string = '';

    constructor(init?:Partial<WhseLabelOthArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class WarehouseReceiptArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<WarehouseReceiptArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class WhseAPArgs extends ReportArgs {
    //dataCompanyID: number = 0;

    constructor(init?:Partial<WhseAPArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class WhseLabelRcptArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    //customer: string = '';
    //formName: string = '';

    constructor(init?:Partial<WhseLabelRcptArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class WhseLabelShipArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //tFontName: string = '';
    //customer: string = '';
    //formName: string = '';

    constructor(init?:Partial<WhseLabelShipArgs>) {
		super();
		Object.assign(this, init);
	}
}
export class WhseRcptPanpArgs extends ReportArgs {
    //dataCompanyID: number = 0;
    //branch: string = '';

    constructor(init?:Partial<WhseRcptPanpArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class GenEmailArgs extends ReportArgs {
    generalMode: boolean = false;
    cfsType: string = '';

    constructor(init?:Partial<GenEmailArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class SalesCostByCustomerArgs extends ReportArgs {
    // 241218: jhlee - Date Range 추가로 인해 변경
    //date: string | null = null;  
    
    fromDate: string | null = null;
    toDate: string | null = null;
    type: string = '';
    rType: string = '';
    salesBasis: string = '';
    department = {}; // <250219 - BI에서 operation을 선택하여 레포트를 뽑을 수 있도록 추가 />
    documentFileName: string = '';
    headerTitle: string = '';
    productCode: string = '';
    parameter: string = '';
    directPrint: boolean = false;
    copies: number = 0;
    useDefaultPrinter: boolean = false;
    isExportToExcel: boolean = false;
    tbName: string = '';
    tbId: string = '';
    exportPath: string = '';
    silentMode: boolean = false;
    customForm: boolean = false;
    emailTemplateName: string = '';
    fileAttachments: string[] = [];
    batchPrintInfos: BatchPrintInfo[] = [];
    
    constructor(init?:Partial<SalesCostByCustomerArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class BusinessQueryArgs extends ReportArgs {
    fromDate: string | null = null;
    toDate: string | null = null;
    
    department: string = '';

    //filter
    branch: string = '';
    category: string = '';
    shipmentType: string = '';
    cargoType: string = '';
    bookingType: string = '';
    moveType: string = '';
    carrierName: string = '';
    pol: string = '';
    pod: string = '';
    salesperson: string = '';
    preparedBy: string = '';

    customerId: number = 0;
    customerName: string = '';
    agentId: number = 0;
    agentName: string = '';
    brokerId: number = 0;
    brokerName: string = '';

    shipperName: string = '';
    consigneeName: string = '';
    notifyPartyName: string = '';
   
    
    constructor(init?:Partial<BusinessQueryArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class AmsManifestArgs extends ReportArgs {
    amsMasterId: number = 0;
    amsVoyageId: number = 0;
    amsMode: string = '';

    constructor(init?:Partial<AmsManifestArgs>) {
        super();
        Object.assign(this, init);
    }
}


export class DeleteHistoryArgs extends ReportArgs {
    reportType: string = '';
    fromDate: string | null = null;
    toDate: string | null = null;
    jobName: string = '';
    jobIndex: number = 0;
    userName: string = '';
    invNewDesignForm: boolean = false;
    crdbNewDesignForm: boolean = false;

    constructor(init?:Partial<DeleteHistoryArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class RecogHistoryArgs extends ReportArgs {
    reportType: string = '';
    fromDate: string | null = null;
    toDate: string | null = null;
    jobName: string = '';
    jobIndex: number = 0;
    userName: string = '';

    constructor(init?:Partial<RecogHistoryArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class ISFHistoryArgs extends ReportArgs {
    dataCompanyID: string = '';
    isfNo: string = '';
    jobId: number = 0;

    constructor(init?:Partial<ISFHistoryArgs>) {
        super();
        Object.assign(this, init);
    }
}
export class DepositClearedArgs extends ReportArgs {
    isDeposit: boolean  = true;
    bankId: number = 0;
    bankName: string = '';
    bankCurrency: string = '';
    clearDate: string | null = null;

    constructor(init?:Partial<DepositClearedArgs>) {
        super();
        Object.assign(this, init);
    }
}

export class ProfitByBillCodeArgs extends ReportArgs {
    acctType: string = '';
    displayType: string = '';
    fromDate: string | null = null;
    toDate: string | null = null;
    fromBillCode: string = '';
    toBillCode: string = '';
    branch: string = '';
    sortProfitAmount : boolean = false;
    selectFieldValue: string = '';

    constructor(init?:Partial<ProfitByBillCodeArgs>) {
        super();
        Object.assign(this, init);
    }
}

//#endregion


export class BatchPrintInfo {
    tbName?: string = '';
    tbId: string = '';
}

export class AuthEntryBatchInfo extends BatchPrintInfo {
    toCompanyId: string = '';
}

export class ArrivalNoticeBatchInfo extends BatchPrintInfo {
    hidePPCC: string = '';
    toCompanyId?: string = '';
}

export class InvoiceBatchInfo extends BatchPrintInfo {
    toCompanyId?: string = '';
}

export class CrDbBatchInfo extends BatchPrintInfo {
}

export class USDABatchInfo extends BatchPrintInfo {
    toCompanyId: string = '';
}

export class AWBBatchInfo extends BatchPrintInfo {
    toCompanyId: string = '';
    shipperName: string = '';
    carrierName: string = '';
    firstCarrier: string = '';
    destCountry: string = '';
}

export class SABatchInfo extends BatchPrintInfo {
}

export class OOHouseBLBatchInfo extends BatchPrintInfo {
    carrierName: string = '';
}

export class CntrTrkUsageArgs extends ReportArgs {
    dateFrom: string = '';
    dateTo: string = '';
    reportType: string = '';

    constructor(init?:Partial<CntrTrkUsageArgs>) {
		super();
		Object.assign(this, init);
	}
}

export class DutyReportArgs extends ReportArgs {
    fromDate: string = '';
    toDate: string = '';
    reportType: string = '';
    reportOption:  string = '';
    opType:  string = '';
    comId: number = 0;
    pendingType:  string = '';
    dateType:  string = 'AD';
    includeDraft:  boolean = false;

    constructor(init?:Partial<DutyReportArgs>) {
		super();
		Object.assign(this, init);
	}
}